import React, { useEffect, useState } from "react";
import TextInput from "../../input/TextField/TextInput";
import { BASE_URL } from "../../../customHooks/config";
import axios from "axios";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Spinner from "../../layout/loader/Spinner";
import { atom, useAtom } from "jotai";
import AutoCompleteSelect from "../../input/autoComplete/AutoCompleteSelect";
import PasswordInput from "../../input/TextField/PasswordInput";
import CheckBox from "../../input/checkBox/CheckBox";

function SignUpForm({ setStep }) {
  const navigate = useNavigate();
  const [locationData, setLocationData] = useState([]);
  const [user, setUser] = useState({
    email: null,
    fullName: null,
    mobileNumber: null,
    location: {},
    firmNameOptional: null,
    website: null,
    password: null,
    checked: false
  });
  const [loading, setLoading] = useState(false);

  function isEmailComplete(email) {
    // Regular expression pattern for basic email validation
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailPattern.test(email);
  }

  const handleSubmit = (e) => {
    e.preventDefault();
  };

  useEffect(() => {
    axios
      .get(`${BASE_URL}api/location/city_state/`)
      .then((res) => {
        setLocationData(res?.data?.data);
      })
      .catch((err) => {
        console.log(err?.data?.error);
      });
  }, []);

  const validation = () => {
    let error = false;
    if (!user?.fullName) {
      error = true;
      toast.error("Please enter your Full Name")
    }
    else if (!user?.mobileNumber || user?.mobileNumber?.length !== 10) {
      error = true;
      toast.error("Please enter valid Mobile Number")
    }
    else if (!user?.firmNameOptional) {
      error = true;
      toast.error("Please enter valid Mobile Number")
    }
    else if (!user?.website) {
      error = true;
      toast.error("Please enter valid website")
    }
    else if (!user?.password) {
      error = true;
      toast.error("Please enter the Password")
    } else if (!user?.checked) {
      error = true;
      toast.error("Please Check the below Terms and Conditions")
    }
    else {
      if (user?.email && !isEmailComplete(user?.email)) {
        error = true;
        toast.error("Please enter valid email")
      } else if (!user?.email) {
        error = true;
        toast.error("Please enter email")
      }
    }
    return error ? false : true;
  }

  const handleSignUp = () => {

    if (validation()) {
      const [firstName, lastName] = user?.fullName?.split(" ");
      const formData = new FormData();
      formData.append("first_name", firstName ?? "");
      formData.append("last_name", lastName ?? "");
      formData.append("email", user?.email);
      formData.append("phone", user?.mobileNumber);
      formData.append("name", user?.firmNameOptional);
      formData.append("website", user?.website);
      formData.append("password", user?.password);
      formData.append("city", user?.location?.city_id);
      formData.append("state", user?.location?.state_id);
      setLoading(true);
      axios
        .post(`${BASE_URL}vendor/login/signup/`, formData, {
          withCredentials: true,
        })
        .then((res) => {
          if (res?.data?.success) {
            toast.success(res?.data?.data?.message);
            navigate("/all-jobs/4");
          } else toast.error(res?.data?.data?.message);
          setLoading(false);
        })
        .catch((err) => {
          toast.error(err?.data?.error);
          setLoading(false);
        });
    }
  }

  const firmName = [
    <div style={{ display: "flex", alignItems: "center" }}>
      Firm name
      <p style={{ color: "#6C757D", fontSize: "12px", marginLeft: "5px" }}>
        (If your don't have any firm, enter your full name here)
      </p>
    </div>,
  ];

  const handleChangeName = (e) => {
    setUser({ ...user, fullName: e.target.value })
  }
  const handleChangeEmail = (e) => {
    setUser({ ...user, email: e.target.value })
  }
  const handleChangePhone = (e) => {
    setUser({ ...user, mobileNumber: e.target.value })
  }
  const handleChangeFirmName = (e) => {
    setUser({ ...user, firmNameOptional: e.target.value })
  }
  const handleChangeWebsite = (e) => {
    setUser({ ...user, website: e.target.value })
  }
  const handleChangePassword = (e) => {
    setUser({ ...user, password: e.target.value })
  }
  const handleChangeChecked = (e) => {
    setUser({ ...user, checked: e.target.checked })
  }


  return (
    <div className="w-8/12 mt-10">
      <TextInput label="Full name" onChange={handleChangeName} />
      <TextInput label="Email" onChange={handleChangeEmail} />
      <TextInput label="Mobile" onChange={handleChangePhone} />
      <TextInput optional={firmName} onChange={handleChangeFirmName} />
      <div className="mb-5">
        <AutoCompleteSelect
          label="Firm Location"
          data={locationData}
          details={{ ...user }}
          setDetails={setUser}
        />
      </div>
      <TextInput label="Website" onChange={handleChangeWebsite} />

      <PasswordInput label="Password" onChange={handleChangePassword} />

      <div>
        <div className="flex items-start  ">
          <div className="mt-[6px]">
            <label
              className="relative flex cursor-pointer items-center rounded-sm p-0"
              for="ripple-on"
              data-ripple-dark="true"
            >
              <input
                type="checkbox"
                onChange={handleChangeChecked}
                className="pl-0 pr-0 mt-0 mb-0 before:content[''] peer relative h-4 w-4 cursor-pointer appearance-none rounded-sm border border-[#94A3B8]  transition-all before:absolute before:top-2/4 before:left-2/4 before:block before:h-7 before:w-7 before:-translate-y-2/4 before:-translate-x-2/4 before:rounded-sm before:bg-blue-gray-500 before:opacity-0 before:transition-opacity checked:border-[#2563EB] checked:bg-[#2563EB] checked:before:bg-[#2563EB] hover:before:opacity-10"
              />
              <div className="pointer-events-none absolute top-2/4 left-2/4 -translate-y-2/4 -translate-x-2/4 text-white opacity-0 transition-opacity peer-checked:opacity-100">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-3.5 w-3.5"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                  stroke="currentColor"
                  stroke-width="1"
                >
                  <path
                    fill-rule="evenodd"
                    d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                    clip-rule="evenodd"
                  ></path>
                </svg>
              </div>
            </label>
          </div>
          <div className="ml-2">
            <label
              for="link-checkbox"
              className=" text-sm  font-extralight text-[#181818] "
            >
              By clicking on continue, you agree to GW Partner’s{" "}
              <a href="https://getwork.org/terms-and-conditions" target="_blank" className="text-[#2563EB]  hover:underline">
                {" "}
                Terms & Conditions
              </a>{" "}
              and{" "}
              <a href="https://getwork.org/privacy-and-cookie-policy" target="_blank" className="text-[#2563EB] hover:underline">
                Privacy Policy
              </a>
            </label>
          </div>
        </div>
      </div>

      <div className="mt-5">
        {" "}
        <button className="btn-primary" onClick={handleSignUp}>
          {loading ? <Spinner /> : "Sign up"}
        </button>
      </div>
      <div className=" mt-5 mb-5">
        <p
          className="text-xs text-[#64748B] text-center"
          style={{ fontFamily: "gilRoy-semibold" }}
        >
          Already have an account?{" "}
          <a
            onClick={() => {
              setStep(1);
            }}
            className="text-[#2563EB] cursor-pointer "
          >
            Log in
          </a>
        </p>
      </div>
    </div>
  );
}

export default SignUpForm;
